import { Role } from "./constants";

export const isAccessible = ({ role, permissions, name, action }) => {
  if (role === Role.SUPERADMIN || role === Role.ADMIN) return true;

  for (const module of Object.values(permissions)) {
    if (
      module.title === name &&
      module.actions.some((a) => a.name === action && a.value)
    ) {
      return true;
    }
  }

  return false;
};
